import actions from 'actions';
import { merge } from 'lodash';
import { ServicesState } from 'types';
import { createReducer } from 'typesafe-actions';

const { fetchProposal, fetchProposalAdditionalData, changeBasicInformation } = actions.proposal;

const initialState: ServicesState = { basic: [], optional: [] };

export default createReducer(initialState).handleAction(
  [fetchProposal, fetchProposalAdditionalData, changeBasicInformation],
  (state, { payload }) => merge({}, state, payload.result.services),
);
